import { render, staticRenderFns } from "./WingsManagement.vue?vue&type=template&id=39486937&scoped=true"
import script from "./WingsManagement.ts?vue&type=script&lang=js&external"
export * from "./WingsManagement.ts?vue&type=script&lang=js&external"
import style0 from "./WingsManagement.vue?vue&type=style&index=0&id=39486937&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39486937",
  null
  
)

export default component.exports